import beth from './images/beth.png';
import birdperson from './images/birdperson.png';
import evilmorty from './images/evilmorty.png';
import gianthead from './images/gianthead.png';
import goldenford from './images/goldenford.png';
import jerry from './images/jerry.png';
import jessica from './images/jessica.png';
import meeseeks from './images/meeseeks.png';
import morty from './images/morty.png';
import mr from './images/mr.png';
import rick from './images/rick.png';
import summer from './images/summer.png';

const images = [
  beth,
  birdperson,
  evilmorty,
  gianthead,
  goldenford,
  jerry,
  jessica,
  meeseeks,
  morty,
  mr,
  rick,
  summer
];

export default images;
